export interface BoothItem{
    title:string;
    subtitle:string,
    imageURL:string,
    linkURL:string
}


export const BoothItems:Array<BoothItem> = [
    {
        title:"Fly,Baby",
        subtitle:"蝶々パーティクルシェーダー",
        imageURL:"flybaby.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/1629266"
    },
    {
        title:"CYBER_SIGNAL",
        subtitle:"サイバネ風UIシェーダー",
        imageURL:"cyber_signal.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/1675060"
    },
    {
        title:"metaBloom",
        subtitle:"開花シェーダー",
        imageURL:"metaBloom.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/1743747"
    },
    {
        title:"CrackedCrack",
        subtitle:"バグ亀裂シェーダー",
        imageURL:"glitch.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/1834513"
    },
    {
        title:"キラキラシェーダー",
        subtitle:"アニメ風キラキラ",
        imageURL:"kirakira.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/1948291"
    },
    {
        title:"PhraseCrystal",
        subtitle:"言葉をユニークなクリスタルに変換",
        imageURL:"phrasecrystal.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/2330126"
    },
    {
        title:"Deco-UI",
        subtitle:"お手軽UIデコレーション",
        imageURL:"deco_ui.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/2826022"
    },
    {
        title:"ExWire",
        subtitle:"ワイヤーシェーダー",
        imageURL:"exwire.png",
        linkURL:"https://nanakorobi-hi.booth.pm/items/2832898"
    },
]
